<template>
  <div class="modal__select">
    <span class="select__subtitle form-group">
      Критерий поиска:
    </span>
    <Select
      class="select__input_criterion"
      :options="searchCriterionsList"
      :default-key="defaultKey"
      :z-index="3000"
      @input="setCriterion"
    />
  </div>
</template>

<script>
import Select from '@/_shared/components/ui/Select';
import { itemsSearch } from '@/stock/constants';
export default {
  components: {
    Select,
  },
  props: {
    defaultKey: {
      type: String,
      default: 'name',
    },
  },
  emits: [
    'on-change',
  ],
  data() {
    return {
      searchCriterionsList: itemsSearch.criterions
    };
  },
  methods: {
    setCriterion(value) {
      this.$emit('on-change', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/_shared/features/search/TypeCriterion.vue